import { render } from "./CartArea.vue?vue&type=template&id=1064e695"
import script from "./CartArea.vue?vue&type=script&lang=js"
export * from "./CartArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__